<script setup lang="ts">
import MarketplaceCancelBtn from '@/modules/marketplace/components/MarketplaceCancelBtn.vue';
import MarketplaceToggleRouteBtn from '@/modules/marketplace/components/MarketplaceToggleRouteBtn.vue';
import { computed } from 'vue';
import { FrontendOrder } from '@/connect/gen/modules/apiengine/services/oms/oms_pb';
import { OmsOrderStatus } from '@/connect/gen/consts/omsconsts_pb';
import { store as vuex } from '@/store/store';
import { OrderStatus } from '@/modules/marketplace/types/marketplace';

const props = withDefaults(
  defineProps<{
    order: FrontendOrder;
    actions?: string[];
    viewOrder: (orderRef: string) => void;
    editOrder: (order: FrontendOrder) => void;
  }>(),
  { actions: () => ['view', 'edit', 'route', 'unroute', 'cancel'] }
);

const hasTraderUserRole = computed(() => vuex.getters.hasTraderUserRole);

const isOrderOpen = computed(
  () =>
    props.order.orderStatus === OmsOrderStatus.OPEN ||
    props.order.orderStatus === OmsOrderStatus.HELD
);
const orderStatus = computed(() => OmsOrderStatus[props.order.orderStatus] as OrderStatus);
</script>

<template>
  <div class="actions d-flex justify-end">
    <MarketplaceCancelBtn
      v-if="actions.includes('cancel') && isOrderOpen"
      icon
      :order-ref="order.orderRef"
      v-on="$listeners"
    />

    <AuroraBtn
      v-if="actions.includes('edit') && isOrderOpen"
      class="icon-action"
      data-test="edit-order-icon"
      :disabled="!hasTraderUserRole"
      icon
      style="margin-top: 5px"
      timeframe="createLoans"
      x-small
      @click="editOrder(order)"
    >
      <VIcon size="24">mdi-pencil</VIcon>
    </AuroraBtn>

    <MarketplaceToggleRouteBtn
      v-if="actions.includes('route') && isOrderOpen"
      icon
      :order-ref="order.orderRef"
      :status="orderStatus"
      v-on="$listeners"
    />

    <VBtn
      class="icon-action"
      data-test="view-order"
      icon
      style="margin-top: 4px"
      x-small
      @click="viewOrder(order.orderRef)"
    >
      <VIcon size="24">mdi-eye</VIcon>
    </VBtn>
  </div>
</template>

<style lang="scss" scoped>
.actions {
  gap: 0.5rem;
  width: 100%;
}
</style>
